import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_reports_loader = _resolveComponent("reports-loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_date_range = _resolveComponent("date-range")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_download_btn = _resolveComponent("download-btn")!
  const _component_delete_report_btn = _resolveComponent("delete-report-btn")!
  const _component_message = _resolveComponent("message")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_reports_loader, {
      "client-id": _ctx.clientId,
      filters: _ctx.filters,
      result: { items: _ctx.reports, total: _ctx.pagination.rowsNumber },
      onLoading: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLoading = $event)),
      "onUpdate:result": _ctx.onLoaded
    }, null, 8, ["client-id", "filters", "result", "onUpdate:result"]),
    _createVNode(_component_q_table, {
      columns: _ctx.columns,
      rows: _ctx.reports,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
      loading: _ctx.isLoading,
      "wrap-cells": "",
      onRequest: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event.pagination))
    }, {
      "body-cell-name": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/albums/${props.row.id}`,
              class: "q-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.value), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-dateRange": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_date_range, {
              "date-of-loss": props.row.client.dateOfLoss,
              range: props.value
            }, null, 8, ["date-of-loss", "range"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-createdAt": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_humanize_time, {
              time: props.value
            }, null, 8, ["time"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-lastModified": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_humanize_time, {
              time: props.value
            }, null, 8, ["time"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_download_btn, {
              "report-id": props.row.id,
              label: "",
              class: "on-left",
              flat: ""
            }, null, 8, ["report-id"]),
            _createVNode(_component_delete_report_btn, {
              report: props.row,
              flat: "",
              round: "",
              onDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remove($event.id)))
            }, null, 8, ["report"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "no-data": _withCtx(() => [
        _createVNode(_component_message, {
          type: "info",
          class: "full-width q-my-sm",
          style: {"font-size":".9rem"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" No albums found. ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "loading"])
  ]))
}